export { default } from './MediaBackgroundImageFluid';
